import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

import { getUniqueId } from '@app/core/string/unique-id'
import { UIModule } from '@app/modules/ui/ui.module'

@UntilDestroy()
@Component({
  selector: 'sb-voice-message-progress-bar',
  templateUrl: './voice-message-progress-bar.component.html',
  styleUrls: ['./voice-message-progress-bar.component.scss'],
  imports: [UIModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoiceMessageProgressBarComponent {
  readonly theme = input.required<'light' | 'dark' | 'locked'>()
  readonly progress = input.required<number>()
  readonly id = getUniqueId(2)
}
